/**
 * Whether the launcher's dev tools (the dev frame, the dev bridge) are on in
 * this page. Always in a dev build. In a production build only when the
 * embedding page opts in BEFORE the widget script loads:
 *
 *   window.UniboIgwDevTools = true;
 *
 * Unibo Reels' dev console does (Sebastian, 2026-10-14: "keep the devtools in
 * reels even when we deploy it"): it loads each tenant's real production
 * bundle, the same file partners embed, so the switch has to be the page's.
 * Partner pages and the Reels sales demo never set it, and nothing in the
 * dev tools runs for them. The tools only fake client-side state (the store,
 * the launcher's runtime); they write nothing to the backend.
 */
declare global {
  interface Window {
    UniboIgwDevTools?: boolean;
  }
}

export const devToolsEnabled: boolean =
  import.meta.env.DEV ||
  (typeof window !== "undefined" && window.UniboIgwDevTools === true);
